import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, createBlock as _createBlock, withCtx as _withCtx, TransitionGroup as _TransitionGroup } from "vue"

const _hoisted_1 = { class: "text-muted" }
const _hoisted_2 = {
  key: 0,
  class: "banner banner-light my-4"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "material-icons-outlined icon-light" }, " info ", -1)
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { key: 2 }
const _hoisted_6 = {
  key: 2,
  class: "flex-col flex space-y-4 mt-4"
}
const _hoisted_7 = {
  key: 3,
  class: "flex flex-col w-full mt-12 mb-12 text-center select-none"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("p", {
  style: {"font-size":"10rem"},
  class: "material-icons-outlined opacity-10"
}, "inventory", -1)
const _hoisted_9 = { class: "opacity-40" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "w-full h-1 bg-gray-200 rounded-md" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FullExercise = _resolveComponent("FullExercise")!
  const _component_ExerciseSolutionContainer = _resolveComponent("ExerciseSolutionContainer")!
  const _component_SlotSkeleton = _resolveComponent("SlotSkeleton")!
  const _component_Btn = _resolveComponent("Btn")!
  const _component_MinimalExercisePreviewSkeleton = _resolveComponent("MinimalExercisePreviewSkeleton")!
  const _component_ExerciseEditorWrapperSkeleton = _resolveComponent("ExerciseEditorWrapperSkeleton")!
  const _component_Spinner = _resolveComponent("Spinner")!
  const _component_VueEternalLoading = _resolveComponent("VueEternalLoading")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("p", _hoisted_1, _toDisplayString(_ctx.$t("exercise_solution_thread.teacher_description")), 1),
    (_ctx.remainingCount > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("p", null, [
            _createTextVNode(_toDisplayString(_ctx.$t("exercise_solution.there_are_pending_solutions_1")) + " ", 1),
            _createElementVNode("strong", null, _toDisplayString(_ctx.remainingCount), 1),
            _createTextVNode(" " + _toDisplayString(_ctx.$t("exercise_solution.there_are_pending_solutions_2")), 1)
          ])
        ]))
      : _createCommentVNode("", true),
    (!_ctx.firstLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createVNode(_TransitionGroup, { name: "quick-bounce" }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.processedExercises, ({ exercise, highlightedSolutionIds }) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "my-8",
                  key: 'thread-e-' + exercise.id
                }, [
                  _createElementVNode("h4", null, _toDisplayString(_ctx.getExerciseTitle(exercise)), 1),
                  _createVNode(_component_FullExercise, { exercise: exercise }, null, 8, ["exercise"]),
                  (!_ctx.loadingSolutionsByExercise[exercise.id])
                    ? _withDirectives((_openBlock(), _createBlock(_component_ExerciseSolutionContainer, {
                        key: 0,
                        class: "",
                        showTitle: false,
                        allowAddSolution: false,
                        showTeacherControls: true,
                        exercise: exercise,
                        solutions: _ctx.getSolutionsForExercise(exercise),
                        showFirst: highlightedSolutionIds,
                        canLoadMore: 
							!(_ctx.mainStore.paginatedSolutionsByExerciseId[exercise.id]?.isLastPage ?? true)
						,
                        onLoadMore: ($event: any) => (_ctx.loadMore(exercise))
                      }, null, 8, ["exercise", "solutions", "showFirst", "canLoadMore", "onLoadMore"])), [
                        [_vShow, _ctx.showSolutionsByExercise[exercise.id]]
                      ])
                    : (_openBlock(), _createBlock(_component_SlotSkeleton, {
                        key: 1,
                        class: "mt-4"
                      })),
                  (
							!_ctx.loadingSolutionsByExercise[exercise.id] &&
							!_ctx.showSolutionsByExercise[exercise.id]
						)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                        _createVNode(_component_Btn, {
                          onClick: ($event: any) => (_ctx.showSolutionsByExercise[exercise.id] = true),
                          size: 'sm',
                          class: "mt-2 -ml-4",
                          variant: 'primary-borderless'
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t("exercise_solution.reveal_solutions_1")) + " " + _toDisplayString(_ctx.getSolutionCountForExercise(exercise)) + " " + _toDisplayString(_ctx.getSolutionCountForExercise(exercise) === 1
									? _ctx.$t("exercise_solution.reveal_solutions_2_singular")
									: _ctx.$t("exercise_solution.reveal_solutions_2_plural")), 1)
                          ]),
                          _: 2
                        }, 1032, ["onClick"])
                      ]))
                    : _createCommentVNode("", true),
                  false
                    ? (_openBlock(), _createBlock(_component_MinimalExercisePreviewSkeleton, { key: 3 }))
                    : _createCommentVNode("", true)
                ]))
              }), 128))
            ]),
            _: 1
          })
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createVNode(_component_ExerciseEditorWrapperSkeleton),
          _createVNode(_component_ExerciseEditorWrapperSkeleton),
          _createVNode(_component_ExerciseEditorWrapperSkeleton),
          _createVNode(_component_ExerciseEditorWrapperSkeleton)
        ])),
    (!_ctx.firstLoading && _ctx.mainStore.exercises.length === 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _hoisted_8,
          _createElementVNode("h2", _hoisted_9, _toDisplayString(_ctx.$t("exercise_solution.no_solutions_to_review")), 1)
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_VueEternalLoading, {
      load: _ctx.onLoadMore,
      "is-initial": _ctx.isInitialInfiniteLoad,
      "onUpdate:is-initial": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.isInitialInfiniteLoad) = $event))
    }, {
      loading: _withCtx(() => [
        _createVNode(_component_Spinner)
      ]),
      "no-more": _withCtx(() => [
        _hoisted_10
      ]),
      _: 1
    }, 8, ["load", "is-initial"])
  ]))
}